// extracted by mini-css-extract-plugin
export default {"enter_game":"home_enter_game__-SgOm"};